import { WhiteSection } from 'components/base/layout-components';
import styled from 'styled-components';
import { StyledWidgetHeader } from '../../CategoriesWidget/CategoriesWidget.style';
import { StyledCategoriesConfig } from './CategoriesConfig/CategoriesConfig.style';
import { getColor } from 'common/constants/_colors';
import { StyledInvestmentBenchmarks } from './InvestmentBenchmarks/InvestmentBenchmarks.style';

export const StyledHeader = styled(StyledWidgetHeader)`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  margin-bottom: 0;
`;

export const StyledSubHeader = styled.header`
  font-size: 1.5rem;
  color: ${getColor('shuttleGray')};
  margin-bottom: 1rem;
`;

export const StyledConfigurationFooter = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledConfiguration = styled.div`
  & ${WhiteSection} {
    padding: 2rem;
  }
  & ${StyledCategoriesConfig} {
    margin-top: 2rem;
  }
  & ${StyledInvestmentBenchmarks} {
    margin-top: 3rem;
  }
  & ${StyledConfigurationFooter} {
    margin-top: 2rem;
  }
`;
